module.exports = __webpack_public_path__ + "img/banner0309_2.758ff417.jpg";